import ErrorCodeHelper from '@dealroadshow/error-codes';
import Dispatcher, { RpcError } from '@dealroadshow/json-rpc-dispatcher';
import messageMapping from '@framework/message/Mapper/messageMapping';
import getRenderedMessage from '../getMessage';
import Logger from '@framework/sentry/Logger';
import { IMessageData, TMessageCode, TMessageName } from '../interfaces';

/**
 * Get message from json rpc error or message code
 * @deprecated Shouldn't be used directly:
 * use `MessageManager.getMessageByName` or `useMessageManager().getMessageByName` instead.
 */
export function getMessage(code: TMessageName, data?: IMessageData) {
  return getRenderedMessage(code, data);
}

/**
 * Get error message from json rpc error
 * @deprecated Shouldn't be used directly:
 * use `MessageManager.getErrorMessage` or `useMessageManager().getErrorMessage` instead.
 */
export function getErrorMessage(
  error: unknown,
  data: IMessageData = {},
) {
  if (Dispatcher.isBrowserAbortError(error)) {
    return getRenderedMessage(messageMapping.fallback);
  }

  if (!(error instanceof RpcError)) {
    Logger.error({ message: 'Error from getErrorMessage, but not RpcError.', error });
    return getRenderedMessage(messageMapping.fallback);
  }

  const fullData = { ...error.getData(), ...data };
  const errorCode = error.getCode();

  if (errorCode === ErrorCodeHelper.getCodeByName('WRAPPED_ERROR') && error.getData().code) {
    const unwrappedError = new RpcError({
      id: error.getId(),
      error: {
        ...error.getData(),
      },
    });

    return getErrorMessage(unwrappedError, data);
  }

// @ts-ignore TODO: FIN-32798 strictNullChecks
  return getRenderedMessage(messageMapping[errorCode], fullData);
}

/**
 * Get error message by code and data
 * @deprecated Shouldn't be used directly:
 * use `MessageManager.getMessageByErrorCode` or `useMessageManager().getMessageByErrorCode` instead.
 */
export function getMessageByErrorCode(
  code: TMessageCode,
  data?: IMessageData,
) {
  return getRenderedMessage(messageMapping[code], data);
}
